// [NT] size-selection-guard.js
// Blocks Add to Cart AND Shopify's accelerated "Buy with Shop"/dynamic
// checkout button until every option (size, boot size, etc.) is explicitly
// selected. The Shop button is a Shopify-hosted component, not a plain
// button, so instead of intercepting its click we lock it visually
// (pointer-events: none) whenever an option is missing, show a prompt above
// it that disappears once everything is selected, and catch clicks on its
// wrapper while locked to show the same red-outline error as the regular
// Add to Cart button.

function dbUnselectSizeFromUrlVariant(scope) {
  // [NT] a URL with ?variant=... makes Shopify auto-check a size on load
  // (common on "Buy with Shop"/subscription links) — undo that for size-type
  // options only, leave color alone
  if (!/[?&]variant=/.test(location.search)) return;
  var fieldsets = scope.querySelectorAll('fieldset.product-form__controls');
  fieldsets.forEach(function (fieldset) {
    if (fieldset.querySelector('.color-swatch')) return;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) checked.checked = false;
  });
}

function dbValidateOptions(scope) {
  var fieldsets = scope.querySelectorAll('fieldset.product-form__controls');
  var firstInvalid = null;

  fieldsets.forEach(function (fieldset) {
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    var select = fieldset.querySelector('select');
    var hasSelection = true;

    if (radios.length) {
      hasSelection = Array.prototype.some.call(radios, function (r) { return r.checked; });
    } else if (select) {
      hasSelection = select.value !== '';
    }

    var msg = fieldset.querySelector('.option-error-message');

    if (!hasSelection) {
      fieldset.classList.add('option-error'); // NT
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'option-error-message'; // NT
        var legend = fieldset.querySelector('legend');
        var label = legend ? legend.textContent.trim() : 'an option';
        msg.textContent = 'Please select ' + label + '.';
        fieldset.appendChild(msg);
      }
      msg.style.display = 'block';
      if (!firstInvalid) firstInvalid = fieldset;
    } else {
      fieldset.classList.remove('option-error');
      if (msg) msg.style.display = 'none';
    }
  });

  return firstInvalid; // null when everything is selected
}

function dbUpdateShopButtonLock(scope) {
  var shopButtonWrapper = scope.querySelector('[data-shopify="payment-button"]');
  if (!shopButtonWrapper) return;

  var fieldsets = scope.querySelectorAll('fieldset.product-form__controls');
  var allSelected = Array.prototype.every.call(fieldsets, function (fieldset) {
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    var select = fieldset.querySelector('select');
    if (radios.length) return Array.prototype.some.call(radios, function (r) { return r.checked; });
    if (select) return select.value !== '';
    return true;
  });

  // [NT] prompt above the Shop button, only shown while an option is missing
  var prompt = shopButtonWrapper.previousElementSibling;
  if (!prompt || !prompt.classList.contains('shop-button-prompt')) {
    prompt = document.createElement('p');
    prompt.className = 'shop-button-prompt'; // NT
    prompt.textContent = 'Please select a size.'; // NT
    shopButtonWrapper.parentNode.insertBefore(prompt, shopButtonWrapper);
  }

  if (allSelected) {
    shopButtonWrapper.classList.remove('shopify-payment-button--locked'); // NT
    prompt.style.display = 'none';
  } else {
    shopButtonWrapper.classList.add('shopify-payment-button--locked'); // NT
    prompt.style.display = 'block';
  }
}

document.addEventListener('click', function (e) {
  // NT: theme's Add to Cart button is handled via JS click, not a real form submit, so we hook the click
  var button = e.target.closest('[name="add"]');
  if (button) {
    var scope = button.closest('[id^="MainProduct-"]') || document;
    var firstInvalid = dbValidateOptions(scope);
    if (firstInvalid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }

  // [NT] catch clicks landing on the locked Shop button wrapper
  var shopWrapper = e.target.closest('[data-shopify="payment-button"]');
  if (shopWrapper && shopWrapper.classList.contains('shopify-payment-button--locked')) {
    var shopScope = shopWrapper.closest('[id^="MainProduct-"]') || document;
    e.preventDefault();
    e.stopImmediatePropagation();
    var firstInvalidForShop = dbValidateOptions(shopScope);
    if (firstInvalidForShop) firstInvalidForShop.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}, true);

document.addEventListener('change', function (e) {
  if (!e.target.matches('input[type="radio"], select')) return;
  var fieldset = e.target.closest('fieldset.product-form__controls');
  if (fieldset) {
    fieldset.classList.remove('option-error');
    var msg = fieldset.querySelector('.option-error-message');
    if (msg) msg.style.display = 'none';
  }
  var scope = e.target.closest('[id^="MainProduct-"]') || document;
  dbUpdateShopButtonLock(scope);
});

function dbInitShopButtonLock() {
  document.querySelectorAll('[id^="MainProduct-"]').forEach(function (scope) {
    dbUnselectSizeFromUrlVariant(scope); // NT
    dbUpdateShopButtonLock(scope);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dbInitShopButtonLock);
} else {
  dbInitShopButtonLock();
}